import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import BlogSingleDetailsTwo from '../../components/blog-components/BlogSingleDetailsTwo';
import FooterOne from '../../common/footer/FooterOne';

const BlogSingleTwo = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Single 2"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Single 2"
        />
        
        <BlogSingleDetailsTwo />
        
        <FooterOne />
        </>
    )
}
    
export default BlogSingleTwo;